import { useMemo } from 'react';
import { usePolledResource } from '../../core/data/usePolledResource';
import { apiList } from '../../core/data/restClient';

/**
 * Admin-only, opened-on-demand subscription to every client id — feeds
 * `ClientDetailPage`'s edit wizard uniqueness check. Gated by `enabled` so
 * the listener only exists while the wizard is open.
 */
export function useAllClientIds(enabled: boolean): Array<{ id: string }> {
  const { rows } = usePolledResource<{ id: string }>(
    enabled ? 'clients' : null,
    () => apiList<{ id: string }>('/clients'),
  );
  return useMemo(() => rows.map((r) => ({ id: r.id })), [rows]);
}
